module.exports = __webpack_public_path__ + "static/media/waterOff.053e1e04.svg";